export const getMonoWeatherwidgetUrl = (stage) => `https://${stage}.d31f8oxjm9u4ad.amplifyapp.com/`;
